'use client';

import { fetchJson } from '@/lib/api/client';
import type { AuthUser } from '@/types/common';

// deactivatedMessage: set when the session cookie names a since-deactivated
// user — the notice the UI shows once before dropping the cookie.
export type AuthMeResponse = { ok: true; user: AuthUser | null; deactivatedMessage: string | null };
type AuthLoginResponse = { ok: true; user: AuthUser };
type AuthSettings = { deactivatedLoginMessage: string };

export const authApi = {
  me(): Promise<AuthMeResponse> {
    return fetchJson<AuthMeResponse>('/api/auth/me');
  },

  login(username: string, password: string): Promise<AuthLoginResponse> {
    return fetchJson<AuthLoginResponse>('/api/auth/login', {
      method: 'POST',
      body: JSON.stringify({ username, password }),
    });
  },

  logout(): Promise<void> {
    return fetchJson<{ ok: true }>('/api/auth/logout', {
      method: 'POST',
    }).then(() => undefined);
  },

  // Admin "Log in as": start acting as another user.
  impersonate(userId: string): Promise<AuthLoginResponse> {
    return fetchJson<AuthLoginResponse>('/api/auth/impersonate', {
      method: 'POST',
      body: JSON.stringify({ userId }),
    });
  },

  // Revert to the real admin behind an impersonated session.
  stopImpersonating(): Promise<AuthLoginResponse> {
    return fetchJson<AuthLoginResponse>('/api/auth/stop-impersonating', {
      method: 'POST',
    });
  },

  settings(): Promise<AuthSettings> {
    return fetchJson<AuthSettings>('/api/admin/auth-settings');
  },

  saveSettings(settings: AuthSettings): Promise<AuthSettings> {
    return fetchJson<AuthSettings>('/api/admin/auth-settings', {
      method: 'PUT',
      body: JSON.stringify(settings),
    });
  },
};
